import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'edit',
        (state.get('edit') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );
}

export function error(state, { errors }) {
    return state.set(
        'edit',
        (state.get('edit') || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(errors))
    );
}

export function finish(state) {
    state = state
        .set(
            'edit',
            (state.get('edit') || Map())
                .set('state', 'FINISHED')
                .set('errors', void 0)
        );

    return state;
}

export function clear(state) {
    return state.set('edit', Map());
}
